module.exports = __webpack_public_path__ + "static/slide-right.505f66ad.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/slide-right.png
// module id = 1053
// module chunks = 2